import React from 'react';
import { View } from 'react-native';

import Text from '../../components/text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';

/**
 * MachineChip: the machine number (e.g. "V-1331") as a clearly readable chip,
 * never footnote text (SPEC decision 6).
 * Props:
 * - number (string): the machine number to show
 * - size: 'regular' (rows) | 'large' (stop screen header)
 * - muted (bool): quieter colours for finished stops
 * - style
 */
const MachineChip = ({ number, size = 'regular', muted = false, style }) => {
	const styles = useThemedStyles(createStyles);

	if (!number) {
		return null;
	}

	return (
		<View
			style={[styles.chip, size === 'large' && styles.chipLarge, muted && styles.chipMuted, style]}
			accessibilityLabel={`Machine ${number}`}
		>
			<Text
				style={[styles.number, size === 'large' && styles.numberLarge, muted && styles.numberMuted]}
				numberOfLines={1}
			>
				{number}
			</Text>
		</View>
	);
};

const createStyles = ({ ui: { colors, radius, type } }) => ({
	chip: {
		alignSelf: 'flex-start',
		borderRadius: radius.tag,
		borderWidth: 1,
		borderColor: colors.borderStrong,
		backgroundColor: colors.chip,
		paddingVertical: 2,
		paddingHorizontal: 8,
	},
	chipLarge: {
		borderRadius: radius.chip,
		paddingVertical: 4,
		paddingHorizontal: 10,
	},
	chipMuted: {
		backgroundColor: 'transparent',
	},
	number: {
		...type.bodySmallStrong,
		color: colors.text,
		letterSpacing: 0.3,
	},
	numberLarge: {
		...type.sectionTitle,
		letterSpacing: 0.3,
	},
	numberMuted: {
		color: colors.textSecondary,
	},
});

export default MachineChip;
